// extracted by mini-css-extract-plugin
export default {"card":"AfaComunicacionsCard_card__LAe3k"};